import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { useNavigate } from 'react-router-dom';
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

function SkillMaster() {


  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Skill Master"))
    fetchSkills();
  }, [])
  const [skills, setSkills] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);
  const navigate = useNavigate();

  const columns = {
    Name: { text: "Skill", visible: true },
    Code: { text: "Code", visible: true },
    SubSkill: { text: "SubSkill", visible: true },
    IsInActive: { text: "Active", align: "center", visible: true },
  };

  const handleAddForm = () => {
    navigate('/skill-master/add');
  }

  const handleEdit = (id) => {
    navigate(`/skill-master/add/${id.ID}`);
  }

  const fetchSkills = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}skill-masters`);
      if (response.status === 200) {
        SetApiStatus(response?.status);
        const parser = new DOMParser();

        const cleanedData = response?.data?.data?.map((skill) => {
          let cleanedSubSkill = skill.SubSkill;
          if (cleanedSubSkill) {
            const parsed = parser.parseFromString(
              `<!doctype html><body>${cleanedSubSkill}`,
              "text/html"
            );
            cleanedSubSkill = parsed.body.textContent.trim();
          }

          return {
            ...skill,
            SubSkill: cleanedSubSkill,
          };
        });

        setSkills(cleanedData);
      } else {
        console.error(
          "Failed to fetch skills. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };


  return (
    <>

      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={skills}
              columns={columns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isSorting={true}
              isSrNoRequired={true}
              isAddNewBtnRequired={true}
              isActionRequired={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              handleAddNew={handleAddForm}
              handleIcon1={handleEdit}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
              }}
            />
          </div>
        </div>
      </div>

    </>
  );
}

export default SkillMaster;
